var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "hiprint-test" },
    [
      _c(
        "a-card",
        { attrs: { title: "hiprint 功能测试", bordered: false } },
        [
          _c(
            "div",
            { attrs: { slot: "extra" }, slot: "extra" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.testAll } },
                [_vm._v("一键测试全部功能")]
              ),
            ],
            1
          ),
          _c(
            "a-space",
            { staticStyle: { "margin-bottom": "20px" } },
            [
              _c("a-button", { on: { click: _vm.testInit } }, [
                _vm._v("1. 测试初始化"),
              ]),
              _c("a-button", { on: { click: _vm.testCreateTemplate } }, [
                _vm._v("2. 创建模板"),
              ]),
              _c("a-button", { on: { click: _vm.testLoadTemplate } }, [
                _vm._v("3. 加载模板JSON"),
              ]),
              _c("a-button", { on: { click: _vm.testRender } }, [
                _vm._v("4. 渲染预览"),
              ]),
              _c("a-button", { on: { click: _vm.testGetHtml } }, [
                _vm._v("5. 获取HTML"),
              ]),
              _c("a-button", { on: { click: _vm.testPrint } }, [
                _vm._v("6. 打印测试"),
              ]),
              _c("a-button", { on: { click: _vm.testGetJson } }, [
                _vm._v("7. 获取模板JSON"),
              ]),
            ],
            1
          ),
          _c("a-divider", [_vm._v("测试结果")]),
          _vm.testResults.length === 0
            ? _c("a-alert", {
                attrs: {
                  message: "点击上方按钮开始测试",
                  type: "info",
                  "show-icon": "",
                },
              })
            : _vm._e(),
          _vm._l(_vm.testResults, function (result, index) {
            return _c(
              "div",
              { key: index, staticStyle: { "margin-bottom": "10px" } },
              [
                _c("a-alert", {
                  attrs: {
                    message: result.name,
                    description: result.details,
                    type: result.success ? "success" : "error",
                    "show-icon": "",
                    closable: "",
                  },
                }),
              ],
              1
            )
          }),
          _c("a-divider", [_vm._v("模板预览")]),
          _c(
            "div",
            { ref: "previewContainer", staticClass: "preview-container" },
            [
              !_vm.previewHtml
                ? _c("a-empty", { attrs: { description: "暂无预览内容" } })
                : _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.previewHtml) },
                  }),
            ],
            1
          ),
          _c("a-divider", [_vm._v("模板 JSON")]),
          _c("a-textarea", {
            staticStyle: { width: "100%", "font-family": "monospace" },
            attrs: { rows: 15, placeholder: "模板JSON内容" },
            model: {
              value: _vm.templateJsonStr,
              callback: function ($$v) {
                _vm.templateJsonStr = $$v
              },
              expression: "templateJsonStr",
            },
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }